import { render, staticRenderFns } from "./KeywordFluInfo.vue?vue&type=template&id=197f8d51&scoped=true"
import script from "./KeywordFluInfo.vue?vue&type=script&lang=js"
export * from "./KeywordFluInfo.vue?vue&type=script&lang=js"
import style0 from "./KeywordFluInfo.vue?vue&type=style&index=0&id=197f8d51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197f8d51",
  null
  
)

export default component.exports